import React, { Component } from "react";
import styled from "styled-components";

const Selected = styled.div`
  display: flex;
  select {
    width: 100%;
    border: none;
    background: #fff;
  }
`;

class SelectField extends Component {
  render() {
    const {
      label,
      field: { onChange, name },
      options,
    } = this.props;

    return (
      <Selected>
        <span>{label}</span>
        <select name={name} onChange={onChange}>
          {options.map(({ name, value }) => (
            <option key={value} value={value}>
              {name}
            </option>
          ))}
        </select>
      </Selected>
    );
  }
}

export default SelectField;
